import { defaultBundleColorLabel } from "./defaultBundleColorLabel";
import variantHasOptionValue from "./variantHasOptionValue";

export default function unifyGroupOptions(product) {
  if (!product) {
    return [];
  }

  const options = {};

  const optionSources = [];

  if (product.group?.products) {
    optionSources.push(...product.group.products);
  }

  optionSources.push(product);

  optionSources.forEach((optionSource) => {
    if (optionSource.bundleColor) {
      const bundleColorLabel =
        product.bundleColorLabel || defaultBundleColorLabel;

      if (!(bundleColorLabel in options)) {
        options[bundleColorLabel] = [];
      }

      options[bundleColorLabel].push({
        name: optionSource.bundleColor.label,
        swatch: null,
        materialGroup: optionSource.materialGroup,
        madeToOrder: false,
      });
    }

    optionSource.options.forEach((option) => {
      if (
        option.name === "Title" &&
        option.optionValues[0]?.name === "Default Title"
      ) {
        return;
      }

      if (!(option.name in options)) {
        options[option.name] = [];
      }
      options[option.name].push(
        ...option.optionValues
          .map((optionValue) => {
            // if (initialVariantHidden) {
            //   // Show only options for current variant
            //   const appliesToInitialVariant = variantHasOptionValue({
            //     variant: initialVariant,
            //     optionName: option.name,
            //     optionValue: optionValue.name,
            //   });

            //   if (!appliesToInitialVariant) {
            //     return null;
            //   }
            // }

            const matchingVariants = optionSource.variants.filter((variant) =>
              variantHasOptionValue({
                variant,
                optionName: option.name,
                optionValue: optionValue.name,
              }),
            );

            const allMatchingVariantsHidden = matchingVariants.every(
              (variant) => JSON.parse(variant.hideOnPdp),
            );

            const firstMatchingVariant = matchingVariants[0];

            let materialGroup = optionSource.materialGroup;
            let madeToOrder = false;

            if (firstMatchingVariant?.materialGroup) {
              materialGroup = firstMatchingVariant?.materialGroup;
              madeToOrder = JSON.parse(firstMatchingVariant.madeToOrder);
            }

            return {
              ...optionValue,
              materialGroup,
              madeToOrder,
              allMatchingVariantsHidden,
            };
          })
          .filter((v) => v),
      );
    });
  });

  const uniqueOptions = Object.entries(options).map(
    ([optionName, optionValues]) => {
      return {
        optionName,
        optionValues: optionValues.filter(
          ({ name }, i) =>
            optionValues.findIndex(
              (optionValue) => optionValue.name === name,
            ) === i,
        ),
      };
    },
  );

  uniqueOptions.forEach((uniqueOption) => {
    uniqueOption.optionValues.forEach((optionValue) => {
      if (optionValue.swatch || !product.group?.bundleColors) return;

      const colorItem = product.group.bundleColors.find(
        ({ label }) => label === optionValue.name,
      );

      if (!colorItem) return;

      optionValue.swatch = {
        image: colorItem.image,
        color: colorItem.color,
      };
    });
  });

  return uniqueOptions;
}
